import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-facultdad-noticias',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './facultdad-noticias.component.html',
  styleUrl: './facultdad-noticias.component.scss'
})
export class FacultdadNoticiasComponent {
  @ViewChild('carouselWrapper') carouselWrapper!: ElementRef;
  @Input() cant: number = 4; 
  @Input() info: any; 
  
  language = "es";
  cards: any[] = [];
  isDesktop: boolean = true;
  currentIndex: number = 0;
  componentId = 'carousel-' + Math.random().toString(36).substring(7);
  carouselTransform: string = 'translateX(0)';
  originalCards: any[] = [];
  isTransitioning: boolean = true;

  ngOnInit(): void {
    this.checkScreenSize();
    if (this.info && this.info.entity) {
      this.originalCards = this.info.entity.map((element: any, index: number) => {
        const processedItem = { ...element, position: index };
        
        if (element.publicationAt?.date) {
          const dateStr = element.publicationAt.date.split(' ')[0]; 
          const [year, month, day] = dateStr.split('-').map(Number);
          const dateObj = new Date(year, month - 1, day);
          processedItem.date = dateObj.toLocaleDateString('es-ES', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          }); 
        }   
        if (element.typeEntity == 'Post') {
          processedItem.systemTitle = this.language + '/noticias/' + element.systemTitle;
        } else if (element.typeEntity == 'Event') {
          processedItem.systemTitle = this.language + '/eventos/' + element.systemTitle;
        } else {
          processedItem.systemTitle = '/' + this.language + element.systemTitle;
        }

        return processedItem;
      });
    }

    this.setupInfiniteCarousel();
  }

  setupInfiniteCarousel(): void {
    if (!this.originalCards.length) return;

    const cloneCount = this.isMobile ? 2 : this.cant;

    const startClones = this.originalCards.slice(-cloneCount);
    const endClones = this.originalCards.slice(0, cloneCount);

    this.cards = [...startClones, ...this.originalCards, ...endClones];
    this.currentIndex = cloneCount; 

    if (this.isMobile) {
      setTimeout(() => this.centerMobileScroll(false), 50);
    } else {
      this.updateCarouselPosition();
    }
  }

  checkScreenSize() {
    const width = window.innerWidth;

    if (width > 1024) {
      this.isDesktop = true;
      this.cant = 4; 
    } else if (width > 738) {
      this.isDesktop = true; 
      this.cant = 2; 
    } else {
      this.isDesktop = false;
      this.cant = 1; 
    }
  }
  inMotion=false;
  moveLeft(): void {
    if(this.inMotion) return;
    this.inMotion = true;
    this.currentIndex--;
    this.isTransitioning = true;
    this.updateCarouselPosition();
  }

  moveRight(): void {
    if(this.inMotion) return;
    this.inMotion = true;
    this.currentIndex++;
    this.isTransitioning = true;
    this.updateCarouselPosition();
  }

  onTransitionEnd(): void {
    if (this.isMobile) return;

    const totalReales = this.originalCards.length;

    if (this.currentIndex >= totalReales + this.cant) {
      this.isTransitioning = false;
      this.currentIndex = this.cant;
      this.updateCarouselPosition();
    }

    if (this.currentIndex < this.cant) {
      this.isTransitioning = false;
      this.currentIndex = totalReales + this.cant - 1;
      this.updateCarouselPosition();
    }
  }

  updateCarouselPosition(): void {
    if (this.isMobile) return;
    const cardWidth = 100 / this.cant;
    const offset = this.currentIndex * cardWidth;
    this.carouselTransform = `translateX(-${offset}%)`;
    this.inMotion = false;
  }

  onMobileScroll(event: Event): void {
    if (!this.isMobile || !this.carouselWrapper) return;

    const container = this.carouselWrapper.nativeElement;
    const scrollLeft = container.scrollLeft;
    const cardWidth = container.offsetWidth * 0.9; 
    const totalReales = this.originalCards.length;

    if (scrollLeft >= (totalReales + 2) * cardWidth) {
      container.style.scrollBehavior = 'auto';
      container.scrollLeft = 2 * cardWidth;
      container.style.scrollBehavior = 'smooth';
    }

    if (scrollLeft <= 0) {
      container.style.scrollBehavior = 'auto';
      container.scrollLeft = totalReales * cardWidth;
      container.style.scrollBehavior = 'smooth';
    }
  }

  centerMobileScroll(smooth: boolean = true): void {
    if (!this.carouselWrapper) return;
    const container = this.carouselWrapper.nativeElement;
    const cardWidth = container.offsetWidth * 0.8;
    
    container.style.scrollBehavior = smooth ? 'smooth' : 'auto';
    container.scrollLeft = 2 * cardWidth; 
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const prevIsMobile = this.isMobile;
    this.checkScreenSize();
    
    //if (prevIsMobile !== this.isMobile) {
      this.setupInfiniteCarousel();
    //}
  }
  
  url(link: any): string {
    if (!link) return '';
    if (this.isExternalUrl(link)) return link;
    if (link.startsWith('/')) link = link.substring(1);
    return `/${this.language}/${link}`;
  }

  isExternalUrl(urlStr: string): boolean {
    return urlStr.startsWith('http://') || urlStr.startsWith('https://');
  }

  get isMobile(): boolean {
    return window.innerWidth <= 738; 
  }
}